import React, { useEffect, useRef } from 'react'
import { Loading } from '@ow/comps'
import { css, Global } from '@emotion/react'
import { pick, castArray } from 'lodash-es'
import {
  useTbViewStore,
  useFetchRemoteData,
  useProjectStore,
  useBeforeTransform,
} from '@vt/hooks'
import { useDataOperateStore } from '../../data-operate/data-operate-store-provider'
import Table from './table'
import Matrix from './matrix'
import CardList from './card-new'
import Calender from './calender'
import File from './file'
import Map from './map'
import ElementRender from '../container-render/ElementRender'
import Statistics from '../../statistics'
// import Appeal from '../../statistics/Appeal'
import Article from './article'
import Chart from './Chart'
import Media from './media'
import ExportMap from './export-map'

const dealSorts = (sorts = []) => {
  const sortMap = {}
  castArray(sorts)
    .filter((v) => v && v.slug)
    .forEach((v) => {
      const { slug, order } = v
      sortMap[slug] = order
    })
  return sortMap
}

const Content = function ({
  footerLayouts,
  afterTransform,
  autoFetchData,
  CustomOperateComponent,
  title,
}) {
  const statisticsRef = useRef(null)
  // const appealRef = useRef(null)

  const { ditto, loading, viewType, id, sorts, matrixInited, fetchTbData } =
    useTbViewStore([
      'ditto',
      'viewType',
      'id',
      'matrixSelected',
      'loading',
      'sorts',
      'matrixInited',
      'fetchTbData',
    ])

  const fetchRemoteData = useFetchRemoteData()
  const { customCompsMap } = useProjectStore((state) =>
    pick(state, ['customCompsMap'])
  )

  const { operators } = useDataOperateStore((state) =>
    pick(state, ['operators'])
  )

  const { showTbDetail, showTbInlineEdit, showCreate } = operators || {}
  // 这里要改,showTbDetail参数没有用到
  const beforeTransform =
    customCompsMap && customCompsMap.useBeforeTransform
      ? customCompsMap.useBeforeTransform({ showTbDetail })
      : useBeforeTransform({
          // ...props,
          showTbDetail,
          // userInfoInApp,
          // onChangeStatus,
        })

  const onShowStatistics = (field) => {
    if (statisticsRef.current) {
      statisticsRef.current.open(field)
    }
  }

  const editTbData = async (data, updateData, extProps) => {
    const originalData = await ditto.getById(data.objectId)
    if (originalData) {
      showCreate({ ...originalData, ...updateData }, extProps)
    }
  }

  useEffect(() => {
    // 保证是第一次请求
    if (viewType !== 'map' && autoFetchData) {
      fetchTbData()
    }
  }, [id])

  return (
    <>
      <Global
        styles={css`
          .dark {
            .BaseTable {
              color: #eaedff;
            }
            .BaseTable__table {
              background-color: transparent;
            }
            .BaseTable__table-frozen-left {
              background-color: var(--ow-color-darkTheme-1100);
            }
            .BaseTable__row:hover,
            .BaseTable__row--hovered {
              background: var(--ow-color-darkTheme-900);
            }
            .BaseTable__header-row {
              background: var(--ow-color-darkTheme-800);
            }

            .BaseTable__header-row {
              border-bottom: 1px solid var(--ow-color-darkTheme-800);
            }
            .BaseTable__row {
              border-bottom: 1px solid var(--ow-color-darkTheme-800);
            }
            .BaseTable__table-frozen-left {
              box-shadow: 1px 0 0 0 var(--ow-color-darkTheme-800);
            }
          }
        `}
      />
      <div
        className="flex flex-1 h-full relative bg-white flex-col dark:bg-darkTheme-1100"
        style={{ gap: '7px' }}
      >
        {title && <div>{title}</div>}
        {(loading || (!matrixInited && viewType === 'matrix')) && (
          <div className="absolute top-0 right-0 w-full h-full flex items-center justify-center z-10 bg-neutral-100 dark:bg-transparent">
            <Loading
              label="加载中"
              style={{ fontSize: '14px' }}
              className="text-primary-700"
            />
          </div>
        )}
        {viewType === 'matrix' && (
          <Matrix
            beforeTransform={beforeTransform}
            showTbDetail={showTbDetail}
            sorts={dealSorts(sorts)}
            onShowStatistics={(field) => {
              onShowStatistics(field)
            }}
            // onShowAppeal={(field) => {
            //   onShowAppeal(field)
            // }}
          />
        )}
        {viewType === 'chart' && (
          <Chart
            beforeTransform={beforeTransform}
            onFetchRemoteData={fetchRemoteData}
          />
        )}
        {(viewType === 'table' ||
          viewType === 'list' ||
          viewType === 'recycle') && (
          <Table
            beforeTransform={beforeTransform}
            afterTransform={afterTransform}
            showTbDetail={showTbDetail}
            showTbInlineEdit={showTbInlineEdit}
            sorts={dealSorts(sorts)}
            editTbData={editTbData}
            onShowStatistics={(field) => {
              onShowStatistics(field)
            }}
            onFetchRemoteData={fetchRemoteData}
            CustomOperateComponent={CustomOperateComponent}
          />
        )}
        {(viewType === 'table' ||
          viewType === 'list' ||
          viewType === 'recycle') && (
          <CardList
            beforeTransform={beforeTransform}
            onFetchRemoteData={fetchRemoteData}
            showTbDetail={showTbDetail}
            // createTbData={createTbData}
            editTbData={editTbData}
          />
        )}

        {viewType === 'calendar' && (
          <Calender showTbDetail={showTbDetail} createTbData={showCreate} />
        )}
        {viewType === 'file' && (
          <File showTbDetail={showTbDetail} createTbData={showCreate} />
        )}
        {viewType === 'map' && <Map />}
        {viewType === 'export-map' && <ExportMap />}
        {viewType === 'article' && <Article />}
        {viewType === 'media' && (
          <Media
            beforeTransform={beforeTransform}
            afterTransform={afterTransform}
            showTbDetail={showTbDetail}
            showTbInlineEdit={showTbInlineEdit}
            editTbData={editTbData}
            onShowStatistics={(field) => {
              onShowStatistics(field)
            }}
            onFetchRemoteData={fetchRemoteData}
            CustomOperateComponent={CustomOperateComponent}
          />
        )}
        {footerLayouts && (
          <div
            className="w-full flex items-center pt-4 justify-between"
            style={{ borderTop: '1px solid #E7E7E7' }}
          >
            <ElementRender layouts={footerLayouts} />
          </div>
        )}
        <Statistics ref={statisticsRef} />
        {/* <Appeal ref={appealRef} /> */}
      </div>
    </>
  )
}

export default Content
